import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.css']
})
export class SubmitButtonComponent implements OnInit {
  @Output()
  submitApplication = new EventEmitter();
  shouldSubmitDisabled = false;

  constructor() {
  }

  ngOnInit() {
  }

  onSubmitClick(): void {
    this.submitApplication.emit();
  }

  set enableDisableSubmitBtn(v: boolean) {
    this.shouldSubmitDisabled = v;
  }

  get enableDisableSubmitBtn() {
    return this.shouldSubmitDisabled;
  }

  shouldDisable(): boolean {
    return this.shouldSubmitDisabled;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/submit-button/submit-button.component.ts